export default __webpack_public_path__ + "static/media/transfers.72c83c71.png";